
export enum SoundNames {
    abandonship_bigwinv2 = "abandonship_bigwinv2",
    ambience = "ambience",
    ambience_bonus = "ambience_bonus",
    anticipator_v2 = "anticipator_v2",
    anticipatorbonus_v2 = "anticipatorbonus_v2",
    clickon = "clickon",
    clickrelease = "clickrelease",
    clickspinbutton = "clickspinbutton",
    collectbutton = "collectbutton",
    collectionani_v2 = "collectionani_v2",
    countuploop = "countuploop",
    deadmansfingers_bonusmusicloop = "deadmansfingers_bonusmusicloop",
    deadmansfingers_musicloop = "deadmansfingers_musicloop",
    deadmansfingers_winmusicloop = "deadmansfingers_winmusicloop",
    freespinawarded = "freespinawarded",
    freespinsmessage_enter = "freespinsmessage_enter",
    freespinsmessage_exit = "freespinsmessage_exit",
    generic_symbolani_generic = "generic_symbolani_generic",
    rainbowchest_win = "rainbowchest_win",
    reelland = "reelland",
    reelspin_normal = "reelspin_normal",
    reelspin_superturbo = "reelspin_superturbo",
    reelspin_turbo = "reelspin_turbo",
    scatterland = "scatterland",
    shivermetimbers_bigwinv2 = "shivermetimbers_bigwinv2",
    symbolwin_bonus = "symbolwin_bonus",
    symbolwin_collect = "symbolwin_collect",
    symbolwin_wild = "symbolwin_wild",
    tharsheblows_bigwinv2 = "tharsheblows_bigwinv2",
    totalwin_tail = "totalwin_tail",
    treasureisland_bigwinv2 = "treasureisland_bigwinv2",
    valuecollected = "valuecollected",
    walktheplank_bigwinv2 = "walktheplank_bigwinv2",
    win_countuploop = "win_countuploop",
    win_tail_low = "win_tail_low",
    win_tail_mid = "win_tail_mid",
    winline = "winline"
}
